import { render, staticRenderFns } from "./publicLoading.vue?vue&type=template&id=c81626f4&scoped=true"
var script = {}
import style0 from "./publicLoading.vue?vue&type=style&index=0&id=c81626f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81626f4",
  null
  
)

export default component.exports